import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/vilicvane/projects/makeflow/boring-router/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "examples"
    }}>{`Examples`}</h1>
    <h2 {...{
      "id": "common"
    }}>{`Common`}</h2>
    <ul>
      <li parentName="ul">
        <a href="https://codesandbox.io/s/github/makeflow/boring-router/tree/master/packages/examples/basic?file=/main.tsx" target="_blank">Basic</a>
        <p parentName="li">{`Simple usages like match, exact match, not found etc.`}</p>
      </li>
      <li parentName="ul">
        <a href="https://codesandbox.io/s/github/makeflow/boring-router/tree/master/packages/examples/route-content?file=/main.tsx" target="_blank">Route Content</a>
        <p parentName="li">{`Example of multiple way to provide content of the `}<inlineCode parentName="p">{`<Route>`}</inlineCode>{` component, including react element, route component, and function as child.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "advanced"
    }}>{`Advanced`}</h2>
    <ul>
      <li parentName="ul">
        <a href="https://codesandbox.io/s/github/makeflow/boring-router/tree/master/packages/examples/lifecycle-hooks?file=/main.tsx&amp;expanddevtools=1" target="_blank">Lifecycle Hooks</a>
        <p parentName="li">{`Lifecycle hooks example including `}<inlineCode parentName="p">{`before/will/after`}</inlineCode>{` hooks and navigation cancellation.`}</p>
      </li>
      <li parentName="ul">
        <a href="https://codesandbox.io/s/github/makeflow/boring-router/tree/master/packages/examples/parallel-routes?file=/main.tsx" target="_blank">Parallel Routes</a>
        <p parentName="li">{`Parallel routes example with sidebar and overlay.`}</p>
      </li>
      <li parentName="ul">
        <a href="https://github.com/mufancom/boring-router/tree/master/packages/examples/server-side-rendering" target="_blank">Server-Side Rendering</a>
        <p parentName="li">{`Basic SSR snippet for reference.`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      